import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';

export class ZRPPopularCategoryVisibilityInViewportApplicationEventModel implements ApplicationEvent {
  type = ApplicationEventType.Search_ZRP_category_view;

  constructor(private action: GATrackingEventType) {}

  getPayload(): any {
    return {
      action: this.action,
      element: '',
    };
  }
}
